(function ($) {
  jQuery(document).ready(function () {
    jQuery(function () {
      jQuery(document).on('click', ".add_session", function (e) {
        e.preventDefault;
        var btn = jQuery(this);
        var session_id = jQuery(this).data('session-id');
        var user_id = jQuery('.section-agenda').data('user-id');
        jQuery.ajax({
          url: myajax.url,
          type: 'POST',
          data: 'action=add_agenda&user_id=' + user_id + "&session=" + session_id,
          success: function success(data) {
            if (data == 1) {
              btn.addClass('active');

              if (btn.hasClass('track-sub-event__icon')) {
                btn.text('-');
              } else {
                btn.find('span').text('Remove');
              }

              btn.removeClass('add_session');
              btn.addClass('remove_session');

              if (jQuery('.sessions .count')[0]) {
                jQuery('.sessions .count').each(function () {
                  var item = jQuery(this).text();

                  if (item) {
                    count = parseInt(item) + 1;
                    jQuery(this).text(count);
                  }
                });
              } else {
                jQuery('.sessions').html('(<span class="count">1</span>)');
              }

              jQuery('[data-session-id]').each(function () {
                if (jQuery(this).data('session-id') == session_id) {
                  jQuery(this).addClass('active');

                  if (jQuery(this).hasClass('track-sub-event__icon')) {
                    jQuery(this).text('-');
                  } else {
                    jQuery(this).find('span').text('Remove');
                  }

                  jQuery(this).removeClass('add_session');
                  jQuery(this).addClass('remove_session');
                }
              });
            }
          }
        });
      });
      jQuery(document).on('click', ".section-agenda .remove_session", function (e) {
        e.preventDefault;
        var btn = jQuery(this);
        var session_id = jQuery(this).data('session-id');
        var user_id = jQuery('.section-agenda').data('user-id');
        jQuery.ajax({
          url: myajax.url,
          type: 'POST',
          data: 'action=remove_agenda&user_id=' + user_id + "&session=" + session_id,
          success: function success(data) {
            if (data == 1) {
              btn.removeClass('active');

              if (btn.hasClass('track-sub-event__icon')) {
                btn.text('+');
              } else {
                btn.find('span').text('Add to my agenda');
              }

              btn.addClass('add_session');
              btn.removeClass('remove_session');

              if (jQuery('.sessions .count')[0]) {
                jQuery('.sessions .count').each(function () {
                  var item = jQuery(this).text();

                  if (item) {
                    count = parseInt(item) - 1;

                    if (count > 0) {
                      jQuery(this).text(count);
                    } else {
                      jQuery('.sessions').html('');
                    }
                  }
                });
              }

              jQuery('[data-session-id]').each(function () {
                if (jQuery(this).data('session-id') == session_id) {
                  jQuery(this).removeClass('active');

                  if (jQuery(this).hasClass('track-sub-event__icon')) {
                    jQuery(this).text('+');
                  } else {
                    jQuery(this).find('span').text('Add to my agenda');
                  }

                  jQuery(this).addClass('add_session');
                  jQuery(this).removeClass('remove_session');
                }
              });
            }
          }
        });
      });
      jQuery(document).on('click', ".s-my-agenda .remove_session", function (e) {
        e.preventDefault;
        var btn = jQuery(this);
        var session_id = jQuery(this).data('session-id');
        var user_id = jQuery('.s-my-agenda').data('user-id');
        jQuery.ajax({
          url: myajax.url,
          type: 'POST',
          data: 'action=remove_agenda&user_id=' + user_id + "&session=" + session_id,
          success: function success(data) {
            if (data == 1) {
              jQuery('.agenda-event').each(function () {
                if (jQuery(this).data('session-id') == session_id) {
                  jQuery(this).remove();
                }
              });

              if (jQuery('.sessions .count')[0]) {
                jQuery('.sessions .count').each(function () {
                  var item = jQuery(this).text();

                  if (item) {
                    count = parseInt(item) - 1;

                    if (count > 0) {
                      jQuery(this).text(count);
                    } else {
                      jQuery('.sessions').html('');
                    }
                  }
                });
              }
            }
          }
        });
      });
      jQuery(document).on('click', ".add_single_session", function (e) {
        e.preventDefault;
        var btn = jQuery(this);
        var session_id = jQuery(this).data('session-id');
        var user_id = jQuery(this).data('user-id');
        jQuery.ajax({
          url: myajax.url,
          type: 'POST',
          data: 'action=add_agenda&user_id=' + user_id + "&session=" + session_id,
          success: function success(data) {
            if (data == 1) {
              btn.addClass('active');
              btn.find('span').text('Remove');
              btn.removeClass('add_single_session');
              btn.addClass('remove_single_session');

              if (jQuery('.sessions .count')[0]) {
                jQuery('.sessions .count').each(function () {
                  var item = jQuery(this).text();

                  if (item) {
                    count = parseInt(item) + 1;
                    jQuery(this).text(count);
                  }
                });
              } else {
                jQuery('.sessions').html('(<span class="count">1</span>)');
              }
            }
          }
        });
      });
      jQuery(document).on('click', ".remove_single_session", function (e) {
        e.preventDefault;
        var btn = jQuery(this);
        var session_id = jQuery(this).data('session-id');
        var user_id = jQuery(this).data('user-id');
        jQuery.ajax({
          url: myajax.url,
          type: 'POST',
          data: 'action=remove_agenda&user_id=' + user_id + "&session=" + session_id,
          success: function success(data) {
            if (data == 1) {
              btn.removeClass('active');

              if (btn.hasClass('track-sub-event__icon')) {
                btn.text('+');
              } else {
                btn.find('span').text('Add to my agenda');
              }

              btn.addClass('add_single_session');
              btn.removeClass('remove_single_session');

              if (jQuery('.sessions .count')[0]) {
                jQuery('.sessions .count').each(function () {
                  var item = jQuery(this).text();

                  if (item) {
                    count = parseInt(item) - 1;

                    if (count > 0) {
                      jQuery(this).text(count);
                    } else {
                      jQuery('.sessions').html('');
                    }
                  }
                });
              }
            }
          }
        });
      });
    });
  });
})(jQuery);